module.exports = __webpack_public_path__ + "fonts/D-DIN.d68d8669.otf";